import HttpClient from "./interfaces/HttpClient";
import PatronList from "../model/PatronList";
import _environment from "../environments/SiteEnvironment";
import _logging_service from "./LoggingService";
import _http_client from "../clients/AxiosHttpClient";

const _target_server = _environment.targetServer;

export class PatreonService {

    constructor(private httpClient: HttpClient) {}

    public async getPatrons(): Promise<PatronList> {
        try {
            return await this.httpClient.get<PatronList>(
                `${_target_server}v1/external-services/patreon/members`);
        } catch (e) {
            _logging_service.log(e);
            throw e;
        }
    }
}

const _patreon_service = new PatreonService(_http_client);

export default _patreon_service;